module.exports = __webpack_public_path__ + "img/icon_aside_excel1.45d6c9b0.svg";